module.exports = __webpack_public_path__ + "media/images/brands/lov_it1-069f6d4bfa897a79189ee0ee50d6fe48.png";